import React from "react";
import Slider from "react-slick";
import "./YtSlider.css";
import ArrowRight from "./ArrowRight.svg";
import ArrowLeft from "./ArrowLeft.svg";

const ytIdeas = [
  {
    id: "KYeNJohsRQU",
    title: "Ramayana Misconceptions Cleared EP01",
    thumbnail: "https://i3.ytimg.com/vi/KYeNJohsRQU/maxresdefault.jpg",
  },
  {
    id: "u4HoyQ1jdRg",
    title: "Haindava Shankaravam - Bhagavad Gita song released by Sriman Gokaraju Gangaraju",
    thumbnail: "https://i3.ytimg.com/vi/u4HoyQ1jdRg/maxresdefault.jpg",
  },
  {
    id: "OIa47XmcmsU",
    title: "Monks on Mission -- A heart-touching documentary on Vijayawada flood relief activities by ISKCON",
    thumbnail: "https://i3.ytimg.com/vi/OIa47XmcmsU/maxresdefault.jpg",
  },
  {
    id: "HdgX4NnMOuA",
    title: "Amaravati Rath Yatra 2025 Highlights | Organized by ISKCON Vijayawada",
    thumbnail: "https://i3.ytimg.com/vi/HdgX4NnMOuA/maxresdefault.jpg",
  },
  {
    id: "3Yo9zxgo4Nk",
    title: "ISKCON Vijayawada Snana Yatra 2025 Highlights | ISKCON Vijayawada",
    thumbnail: "https://i3.ytimg.com/vi/3Yo9zxgo4Nk/maxresdefault.jpg",
  },
  {
    id: "CfWvgfPpBoc",
    title: "Gaura Purnima Promo 2025 || ISKCON Vijayawada || Sri Chaitanya Mahaprabhu",
    thumbnail: "http://i3.ytimg.com/vi/CfWvgfPpBoc/hqdefault.jpg",
  },
  // {
  //   id: "4Zpubwc6HOI",
  //   title: `భగవద్గీత నిజంగా మనకి ఆనందాన్నిస్తుందా?? | Shastra Chakshu | HG Chakradhari Das`,
  //   thumbnail: "https://i3.ytimg.com/vi/4Zpubwc6HOI/maxresdefault.jpg",
  // },
  // {
  //   id: "B6t5Dh_lIu4",
  //   title: `Sri Krishna Lila Madhuri | Janmashtami Special | Day 1 | తెలుగు | HG Chakradhari Das`,
  //   thumbnail: "https://i3.ytimg.com/vi/B6t5Dh_lIu4/maxresdefault.jpg",
  // },
  // {
  //   id: "BrswVWQZJ5A",
  //   title: `శ్రీ జగన్నాథ లీలామృతం | RathYatra Spl | Day 1 | HG Chakradhari Das`,
  //   thumbnail: "https://i3.ytimg.com/vi/BrswVWQZJ5A/maxresdefault.jpg",
  // },
  // {
  //   id: "ca9fuZGbHaY",
  //   title: `Book Marathan Warriors`,
  //   thumbnail: "https://i3.ytimg.com/vi/ca9fuZGbHaY/maxresdefault.jpg",
  // },
  // {
  //   id: "hULK6WEi_4M",
  //   title: `PRERNA Youth Festival | Search For Happiness | తెలుగు | HG Chakradhari Das`,
  //   thumbnail: "https://i3.ytimg.com/vi/hULK6WEi_4M/maxresdefault.jpg",
  // },
  // {
  //   id: "ayBApn0SnS0",
  //   title: "BHAKTI SHASTRI Upadeshamrtam Sloka 1 PART 1",
  //   thumbnail: "https://img.youtube.com/vi/ayBApn0SnS0/maxresdefault.jpg",
  // },
  // {
  //   id: "zLro71sgg6s",
  //   title: "BHAKTI SHASTRI Upadeshamrtam Sloka 1 PART 2",
  //   thumbnail: "https://img.youtube.com/vi/zLro71sgg6s/maxresdefault.jpg",
  // },
  // {
  //   id: "R2kfRjYaHfw",
  //   title: "BHAKTI SHASTRI Upadeshamrtam Sloka 1 PART 3",
  //   thumbnail: "https://img.youtube.com/vi/R2kfRjYaHfw/maxresdefault.jpg",
  // },
  // {
  //   id: "SeDxW8CLlC4",
  //   title: "BHAKTI SHASTRI Upadeshamrtam Sloka 2",
  //   thumbnail: "https://img.youtube.com/vi/SeDxW8CLlC4/maxresdefault.jpg",
  // },
  // {
  //   id: "0RHUMLEgSb0",
  //   title: "BHAKTI SHASTRI Upadeshamrtam Sloka 3",
  //   thumbnail: "https://img.youtube.com/vi/0RHUMLEgSb0/maxresdefault.jpg",
  // },
  // {
  //   id: "8v2HBz-amRA",
  //   title: "BHAKTI SHASTRI Upadeshamrtam Sloka 4",
  //   thumbnail: "https://img.youtube.com/vi/8v2HBz-amRA/maxresdefault.jpg",
  // },
];


const NextArrow = (props) => {
  const { style, onClick } = props;
  return (
    <button
      className="btn ytBtn"
      style={{
        ...style,
        position: "absolute",
        top: "35%",
        right: "-5%",
      }}
      onClick={onClick}
    >
      <img
        loading="lazy"
        src={ArrowRight}
        alt="Next"
        style={{ width: "25px" }}
      />
    </button>
  );
};

const PrevArrow = (props) => {
  const { style, onClick } = props;
  return (
    <button
      className="btn ytBtn"
      style={{
        ...style,
        position: "absolute",
        top: "35%",
        left: "-5%",
        zIndex: "2",
      }}
      onClick={onClick}
    >
      <img
        loading="lazy"
        src={ArrowLeft}
        alt="Previous"
        style={{ width: "25px" }}
      />
    </button>
  );
};

const YouTubeSlider = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="youtube-slider-container pb-4">
      <Slider {...settings}>
        {ytIdeas.map((video, index) => (
          <div key={index} className="video-slide">
            <div className="ytCard">
              <a
                href={`https://www.youtube.com/watch?v=${video.id}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <img
                  loading="lazy"
                  src={video.thumbnail}
                  alt={video.title}
                  className="video-thumbnail"
                />
                <div className="bottomCard">
                  <h3 className="video-title">{video.title}</h3>
                </div>
              </a>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default YouTubeSlider;
